export default __webpack_public_path__ + "static/nexgen-learn-coding-80115c32c62ca5dfeddab1541e129ec7.webp";